import { Component } from '@angular/core';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { RestrictionsTableComponent } from 'src/app/components/restrictions-table/restrictions-table.component';

@Component({
  selector: 'app-archived-restrictions',
  standalone: true,
  imports: [HeaderComponent, RestrictionsTableComponent],
  templateUrl: './archived-restrictions.component.html',
  styleUrl: './archived-restrictions.component.scss',
})
export class ArchivedRestrictionsComponent {}
